import { render, staticRenderFns } from "./form-table.vue?vue&type=template&id=f60492ea&scoped=true&"
import script from "./form-table.vue?vue&type=script&lang=js&"
export * from "./form-table.vue?vue&type=script&lang=js&"
import style0 from "./form-table.vue?vue&type=style&index=0&id=f60492ea&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f60492ea",
  null
  
)

export default component.exports